<template>
  <stat :title="$t('dashboard.gainssum.title')" :loading="loading">
    <div class="stat">
      <price class="price" v-if="total !== undefined" :value="total"></price>
      <div class="date">
        <date v-if="from" :value="from" format="short"></date>
        -
        <date v-if="to" :value="to" format="short"></date>
      </div>
    </div>
  </stat>
</template>

<script>
  import { Price, Date as DateFormatter } from '@/components/formatters'
  import Stat from '@/components/Stat.vue'
  import stats from '@/mixins/stats'
  export default {
    components: {
      Price,
      Date: DateFormatter,
      Stat
    },
    mixins: [stats],
    props: {
      dataKey: {
        type: String,
        default: 'gains'
      }
    }
  }
</script>

<style scoped>
  .stat {
    height: 200px;
  }

  .price {
    line-height: 150px;
  }

  .date {
    font-size: .5em
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/GainsSum.vue